import { Image } from "antd";
import elementalSvg from "../assets/image/elemental 'e'.svg";
import useCheckModule from "../hooks/useCheckModule";
import { useTenantStore } from "../stores/tenantStore";
import { useUserStore } from "../stores/userStore";
import { checkSuperAdminPriviledge, includesIgnoreCase } from "../utils/utils";
interface ProtectedModuleRouteProps {
	moduleKey: string;
	children: React.ReactNode;
	fallback?: React.ReactNode;
	reportingType?: string;
}

function defaultFallback() {
	return (
		<div className="no-access-container">
			<div className="hexlock-container">
				<div className="noaccess-icon">
					<Image
						preview={false}
						width={"185px"}
						className="home-logo no-visual-search"
						src={elementalSvg}
						alt="Logo"
					/>
				</div>
			</div>
			<span
				style={{
					fontSize: "20px",
					lineHeight: "30px",
					textAlign: "center",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<span>
					Your current subscription does not have access to this page.
				</span>
				<span>
					Please contact{" "}
					<a href="mailto:terra@elementalenergies.com">
						terra@elementalenergies.com
					</a>
					.
				</span>
			</span>
		</div>
	);
}

const userIsNotAuthorizedInModuleFallback = () => {
	return (
		<div className="no-access-container">
			<div className="hexlock-container">
				<div className="noaccess-icon">
					<Image
						preview={false}
						width={"185px"}
						className="home-logo no-visual-search"
						src={elementalSvg}
						alt="Logo"
					/>
				</div>
			</div>
			<span
				style={{
					fontSize: "20px",
					lineHeight: "30px",
					textAlign: "center",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<span>You are not authorized to access this module.</span>
				<span>
					Please contact{" "}
					<a href="mailto:terra@elementalenergies.com">
						terra@elementalenergies.com
					</a>
					.
				</span>
			</span>
		</div>
	);
};

const ProtectedModuleRoute = ({
	moduleKey,
	children,
	fallback,
	reportingType,
}: ProtectedModuleRouteProps) => {
	const currentTenant = useTenantStore((s) => s.tenant);

	const userStore = useUserStore();
	const currentUser = userStore.getCurrentUser();
	const userEmail = currentUser?.email?.toLowerCase();
	const userRoles = userStore.getUserRole();

	const { checkModule } = useCheckModule();
	const isSuperAdmin = checkSuperAdminPriviledge(userRoles);

	// Check if module is enabled
	const isModuleEnabled = checkModule(moduleKey);

	// Check if user is authorized to access this module
	const userIsAuthorized = includesIgnoreCase(
		currentTenant?.modules_authorized_users?.[moduleKey],
		userEmail
	);

	if (!isModuleEnabled) {
		return fallback || defaultFallback();
	}

	if (
		!isSuperAdmin &&
		["reporting", "lessons-learned"].includes(moduleKey) &&
		!userIsAuthorized
	) {
		return userIsNotAuthorizedInModuleFallback();
	}

	// Check if the specific reporting type is enabled for this tenant
	if (
		!isSuperAdmin &&
		reportingType &&
		!currentTenant?.enabled_reporting_types?.includes(reportingType)
	) {
		return userIsNotAuthorizedInModuleFallback();
	}

	return <>{children}</>;
};

export default ProtectedModuleRoute;
